import type { DocumentNode } from 'graphql';

import {
	preloadPrefilteredExtensionList,
	type Extension,
	type UsePreFilteredExtensionsQueryOptions,
} from '@atlassian/forge-ui';

import type { QueryInteropSupportedArgs } from '@confluence/apollo-relay-interop/entry-points/query.ts';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

export const preloadForgeApps = async ({
	cloudId,
	locale,
	types,
	context,
	includeHidden,
}: UsePreFilteredExtensionsQueryOptions): Promise<Extension[] | null> => {
	return preloadPrefilteredExtensionList(
		// This is s a special case that the query is from platform in DocumentNode not Relay TaggedNode
		// query can handle both Relay TaggedNode and DocumentNode but type is only declared as Relay TaggedNode
		queryAgg as unknown as <T, V extends Record<string, any>>(
			options: Omit<QueryInteropSupportedArgs<T, V>, 'query'> & { query: DocumentNode },
		) => Promise<{ data: T | null }>,
		{
			cloudId,
			locale,
			types,
			context,
			includeHidden,
		},
	);
};
